<template>
  <figure
    class="flex flex-col md:grid mx-auto md:grid-cols-3 xl:grid-cols-4 grid-rows-3 md:grid-rows-1 overflow-hidden bg-gradient-from-bl from-gray-900 bg-gradient-to-tr to-gray-800 rounded-lg border-gray-600 border"
  >
    <div v-if="!flipped">
      <img
        class="sm:inline order-1 md:order-none row-span-1 sm:row-span-2 mx-auto md:row-auto object-cover rounded-full sm:rounded-none w-52 h-52 sm:w-full sm:h-full mt-6 sm:mt-0 border-gray-600 sm:border-none border"
        :src="img"
        :alt="`${name} testimonial photo`"
      />
    </div>
    <div
      class="row-span-2 order-2 md:order-none sm:row-span-1 md:col-span-2 xl:col-span-3 px-6 py-6 sm:px-10 sm:py-8"
    >
      <blockquote class="mb-6">
        <p class="sm:text-lg font-light">
          {{ quote }}
        </p>
      </blockquote>
      <figcaption>
        <a
          class="text-2xl font-bold mb-2"
          :style="{ color }"
          :href="link"
          target="_blank"
          >{{ name }}</a
        >
        <p class="text-sm font-light text-white text-opacity-50">
          {{ credentials }}
        </p>
      </figcaption>
    </div>
    <div v-if="flipped">
      <img
        class="sm:inline order-1 md:order-none row-span-1 sm:row-span-2 mx-auto md:row-auto object-cover rounded-full sm:rounded-none w-52 h-52 sm:w-full sm:h-full mt-6 sm:mt-0 border-gray-600 sm:border-none border"
        :src="img"
        :alt="`${name} testimonial photo`"
      />
    </div>
  </figure>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TestimonialCard",
  setup(props) {
    return {
      ...props
    };
  },
  props: {
    name: String,
    quote: String,
    credentials: String,
    img: String,
    link: String,
    color: String,
    flipped: Boolean
  }
});
</script>
